import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { TABLET_PORTRAIT_WIDTH } from 'helpers/constants'
import store from '..'
import { disableScrolling, enableScrolling } from '../../helpers/functions'

@Module({ namespaced: true })
export default class MobileMenuModule extends VuexModule {
  isOpen = false

  openSubmenuIndex: number | null = null

  @Mutation
  open(): void {
    this.isOpen = true
    disableScrolling()
  }

  @Mutation
  close(): void {
    this.isOpen = false
    this.openSubmenuIndex = null
    enableScrolling()
  }

  @Mutation
  toggle(): void {
    this.isOpen ? store.commit('mobileMenu/close') : store.commit('mobileMenu/open')
  }

  @Mutation
  toggleSubMenu(index: number) {
    this.openSubmenuIndex = this.openSubmenuIndex === index ? null : index
  }

  @Action
  addTouchEvents(): void {
    const TRESHOLD = 175
    const SWIPER_CLASSES = [
      { include: 'hero-text-media', exclude: 'single-slide' },
      { include: 'scrollactive-nav', exclude: '' },
      { include: 'ignore-mobile-menu-swipe', exclude: '' }
    ]
    const ELEMENT_FOR_TOUCH_EVENTS = document
    let touchstartX: null | number = null
    let touchendX: null | number = null

    // function handleGesture() {
    //   if (touchendX && touchstartX) {
    //     if (touchendX < touchstartX - TRESHOLD) store.commit('mobileMenu/close')
    //     if (touchendX > touchstartX + TRESHOLD) store.commit('mobileMenu/open')
    //     touchendX = null
    //     touchstartX = null
    //   }
    // }

    ELEMENT_FOR_TOUCH_EVENTS.addEventListener('touchstart', (event: TouchEvent) => {
      // mobile menu is only visible on tablet portrait and phone
      if (window.innerWidth > TABLET_PORTRAIT_WIDTH) return
      const path = event.composedPath() as HTMLElement[]
      const containsSwiperElement = path.some((element) => {
        return element?.classList &&
          SWIPER_CLASSES.some(className => element.classList.contains(className.include) && !element.classList.contains(className.exclude))
      })

      if (containsSwiperElement) return

      touchstartX = event.changedTouches[0].screenX
    })

    ELEMENT_FOR_TOUCH_EVENTS.addEventListener('touchend', (event: TouchEvent) => {
      // mobile menu is only visible on tablet portrait and phone
      if (window.innerWidth > TABLET_PORTRAIT_WIDTH) return
      touchendX = event.changedTouches[0].screenX
      // handleGesture()
    })
  }
}
